export default __webpack_public_path__ + "static/media/close_blue.29d89926.svg";